<style lang="scss" scoped>
/* 中控↔车架绑定弹窗：查询条 → 待解绑清单 → 合并提示 → 左中控/右车架双列表单 */
.binding__bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}

.binding__input {
    width: 280px;
    max-width: 100%;
}

.binding__arrow {
    color: #909399;
    font-weight: bold;
}

.binding__alert {
    margin-bottom: 12px;
}

.binding__alert-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 6px;
}

.binding__block {
    margin-top: 20px;
    margin-bottom: 12px;
}

.binding__block-head {
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: bold;
    color: #303133;
}

.binding__forms {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
}

.binding__forms .binding__card {
    flex: 1;
    min-width: 0;
    margin-bottom: 0;
}

.binding__paste {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 12px;
}

.binding__paste .el-input {
    flex: 1;
}

.binding__paste-btn {
    flex-shrink: 0;
}

.binding__card {
    margin-bottom: 12px;
}

.binding__card-head {
    font-weight: bold;
}

.binding__replace {
    margin-top: 4px;
    font-size: 12px;
    line-height: 18px;
}

/* 窄屏：查询条降宽；两列绑定表单堆叠为上下 */
@media (max-width: 600px) {
    .binding__input { width: 100%; }
}

@media (max-width: 768px) {
    .binding__forms { flex-direction: column; }
}
</style>

<style lang="scss">
/* append-to-body 弹窗脱离组件作用域：宽度由 c-el-dialog(96%) 自适应，修饰类单独封顶 */
.asset-dialog--control-binding {
    margin-top: 5vh !important;
    max-width: 760px;

    .el-input.is-disabled .el-input__inner,
    .el-input--readonly .el-input__inner {
        color: #303133;
    }

    /* 两列窄栏下日期选择器随栏宽自适应 */
    .el-date-editor {
        width: 100%;
        max-width: 100%;
    }
}
</style>

<template>
    <el-dialog title="中控 ↔ 车架绑定" :visible.sync="visible" append-to-body custom-class="c-el-dialog asset-dialog asset-dialog--control-binding" :close-on-click-modal="false" @closed="resetAll">
        <div class="binding">
            <!-- 快速录入：粘贴混合文本，一键识别中控号与车架号并查询 -->
            <div class="binding__paste">
                <el-input v-model="pasteText" type="textarea" :rows="2" resize="none" placeholder="粘贴文本自动识别，如：新中控 867567042615484 车架号 228322411034573" />
                <el-button class="binding__paste-btn" size="medium" :disabled="!pasteText.trim()" @click="parsePaste"><i class="fa fa-magic"></i> 识别并查询</el-button>
            </div>

            <!-- 查询条：两个编号齐全才能查，回车即查；查询结果是本次绑定的冲突快照 -->
            <div class="binding__bar">
                <el-input v-model.trim="controlNo" class="binding__input" size="medium" clearable @keyup.enter.native="search">
                    <template slot="prepend">中控号</template>
                </el-input>
                <span class="binding__arrow">↔</span>
                <el-input v-model.trim="chassisNo" class="binding__input" size="medium" clearable @keyup.enter.native="search">
                    <template slot="prepend">车架号</template>
                </el-input>
                <el-button type="primary" size="medium" :loading="searching" :disabled="!bothFilled" @click="search"><i class="fa fa-search"></i> 查询</el-button>
            </div>

            <!-- 待解绑清单：加载后且确有占用时显示 -->
            <div v-if="loaded && occupants.length" class="binding__block">
                <el-divider content-position="center">待解绑清单</el-divider>
                <el-table :data="occupants" border size="mini" max-height="220">
                    <el-table-column label="中控号" prop="controlNo" min-width="140" show-overflow-tooltip />
                    <el-table-column label="当前车架号" prop="chassisNo" min-width="140" show-overflow-tooltip />
                    <el-table-column label="说明" min-width="220">
                        <template>将自动解绑当前关联</template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 合并提示：未加载时紧跟查询条，加载后落在表格与绑定信息之间；主标题=动作摘要，描述行=中控/车架建档状态标签 -->
            <el-alert class="binding__alert" :type="alertType" :closable="false" show-icon>
                <template slot="title">{{ alertTitle }}</template>
                <div v-if="loaded" slot="description" class="binding__alert-tags">
                    <el-tag size="mini" :type="ctrlRow ? 'warning' : 'success'">{{ ctrlTagText }}</el-tag>
                    <el-tag size="mini" :type="chaRow ? 'warning' : 'success'">{{ chaTagText }}</el-tag>
                </div>
            </el-alert>

            <template v-if="loaded">
                <!-- 绑定表单：左中控 / 右车架两列并排，小屏堆叠；编号只读（以顶部查询为准），其余字段各自可填并从档案回填 -->
                <div class="binding__forms">
                    <el-card shadow="never" class="binding__card">
                        <div slot="header" class="binding__card-head">中控信息</div>
                        <el-form :model="controlForm" label-width="100px" size="small" @submit.native.prevent="save">
                            <el-form-item label="中控号">
                                <el-input :value="controlForm.controlNo" readonly />
                                <div v-if="oldChassis" class="binding__replace col_warning">旧绑定车架 {{ oldChassis }} 将被替换成新车架 {{ chassisNo }}</div>
                            </el-form-item>
                            <el-form-item label="中控 SN"><el-input v-model.trim="controlForm.controlSN" maxlength="32" show-word-limit :disabled="!canBind" /></el-form-item>
                            <el-form-item label="中控型号"><el-input v-model.trim="controlForm.model" maxlength="50" show-word-limit :disabled="!canBind" /></el-form-item>
                            <el-form-item label="设备到期日期"><el-date-picker v-model="controlForm.deviceExpiryDate" type="date" value-format="yyyy-MM-dd" clearable :disabled="!canBind" /></el-form-item>
                        </el-form>
                    </el-card>
                    <el-card shadow="never" class="binding__card">
                        <div slot="header" class="binding__card-head">车架信息</div>
                        <el-form :model="chassisForm" label-width="100px" size="small" @submit.native.prevent="save">
                            <el-form-item label="车架号"><el-input :value="chassisForm.chassisNo" readonly /></el-form-item>
                            <el-form-item label="电机号"><el-input v-model.trim="chassisForm.motorNo" maxlength="32" show-word-limit :disabled="!canBind" /></el-form-item>
                            <el-form-item label="车架型号"><el-input v-model.trim="chassisForm.model" maxlength="50" show-word-limit :disabled="!canBind" /></el-form-item>
                        </el-form>
                    </el-card>
                </div>
            </template>
        </div>
        <span slot="footer">
            <el-button :disabled="saving" @click="visible = false">取消</el-button>
            <el-button type="primary" :loading="saving" :disabled="!canBind" @click="save"><i class="fa fa-link"></i> 确认绑定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    // 中控↔车架绑定：按车架号查出占用者（待解绑清单），下半区左中控 / 右车架两张建档表单
    // 一次保存完成：新建/更新车架档案 → 解绑占用中控 → 新建/更新输入中控并绑定目标车架
    import { controlApi, chassisApi } from '@/api/vehicleData'

    const blankControl = () => ({ controlNo: '', controlSN: '', model: '', deviceExpiryDate: null })
    const blankChassis = () => ({ chassisNo: '', motorNo: '', model: '' })

    export default {
        name: 'ControlBindingDialog',
        data() {
            return {
                visible: false, searching: false, saving: false,
                // searchSeq：查询序号，resetAll 递增以作废在途查询，防止关闭后旧响应回填数据
                searchSeq: 0,
                pasteText: '', controlNo: '', chassisNo: '',
                // queriedKey / queriedChassis：查询快照对应的编号，编号一改动即判定快照过期
                loaded: false, queriedKey: '', queriedChassis: '', ctrlRow: null, chaRow: null, occupants: [],
                controlForm: blankControl(), chassisForm: blankChassis()
            }
        },
        computed: {
            bothFilled() { return !!(this.controlNo && this.chassisNo) },
            // 查询后改动任一编号即视为快照过期，禁止直接保存
            dirty() { return this.loaded && (this.queriedKey !== this.controlNo || this.queriedChassis !== this.chassisNo) },
            canBind() { return this.loaded && !this.dirty && !this.searching && !this.saving },
            // 输入中控自身的旧绑定（与目标车架不同才提示）
            oldChassis() {
                if (!this.ctrlRow) return ''
                const old = (this.ctrlRow.chassisNo || '').trim()
                return old && old !== this.chassisNo ? old : ''
            },
            // 合并提示：主标题按状态给动作摘要，类型给语义色；未加载时也常驻显示引导文案
            alertType() {
                if (this.searching) return 'warning'
                if (!this.loaded) return 'info'
                if (this.occupants.length || this.oldChassis) return 'info'
                return 'success'
            },
            alertTitle() {
                if (this.searching) return '正在查询该车架的占用情况…'
                if (!this.loaded) return this.bothFilled ? '点击「查询」加载该车架的占用与档案情况' : '请输入中控号与车架号后查询'
                if (this.occupants.length) return `检测到该车架已绑定 ${this.occupants.length} 个中控`
                if (this.oldChassis) return `该中控将从车架 ${this.oldChassis} 改绑到 ${this.chassisNo}`
                if (this.ctrlRow && !this.oldChassis) return '该中控与车架已是绑定关系，无需解绑，可直接更新档案'
                return '未发现占用该车架的中控，可直接绑定'
            },
            ctrlTagText() { return this.ctrlRow ? `中控 ${this.ctrlRow.controlNo} 已存在 · 将更新` : `中控 ${this.controlNo} 无档案 · 将新建` },
            chaTagText() { return this.chaRow ? `车架 ${this.chaRow.chassisNo} 已建档 · 将更新` : `车架 ${this.chassisNo} 无档案 · 将新建` }
        },
        watch: {
            // 查询后修改顶部任一编号即作废上次快照，必须重新查询核对后才能保存
            controlNo() { if (this.loaded) this.clearResults() },
            chassisNo() { if (this.loaded) this.clearResults() }
        },
        methods: {
            open() {
                this.resetAll()
                this.visible = true
            },
            resetAll() {
                this.searchSeq++ // 作废在途查询，关闭后即使请求返回也不再回填
                Object.assign(this, { searching: false, saving: false, pasteText: '', controlNo: '', chassisNo: '', loaded: false, queriedKey: '', queriedChassis: '', ctrlRow: null, chaRow: null, occupants: [] })
                this.controlForm = blankControl()
                this.chassisForm = blankChassis()
            },
            // 仅清除查询结果（保留已录入的编号与粘贴文本），用于编号变更后强制重新查询
            clearResults() {
                this.searchSeq++ // 作废在途查询，避免旧响应回填已作废的快照
                Object.assign(this, { searching: false, loaded: false, queriedKey: '', queriedChassis: '', ctrlRow: null, chaRow: null, occupants: [] })
                this.controlForm = blankControl()
                this.chassisForm = blankChassis()
            },
            // 快速录入：从粘贴文本中提取数字串，按规则判定中控号/车架号，填入后立即查询
            // 规则：① 仅取 >12 位的数字串为候选（忽略日期/序号等短数字噪声），不足或多于两个则提示手动录入；② 恰好一个 8 开头则它为中控、另一个为车架；③ 否则按出现顺序前中控后车架
            parsePaste() {
                // 提取全部数字串，只保留 >12 位的作为候选号码
                const runs = ((this.pasteText || '').match(/\d+/g) || []).filter(group => group.length > 12)
                if (runs.length > 2) return this.$message.warning('识别到多个号码，请手动录入')
                if (runs.length < 2) return this.$message.warning('未识别到完整的中控号和车架号（号码需大于12位），请手动录入')
                const [first, second] = runs
                const firstIsControl = first.startsWith('8') !== second.startsWith('8') ? first.startsWith('8') : true
                this.controlNo = firstIsControl ? first : second
                this.chassisNo = firstIsControl ? second : first
                // 识别成功并填入两框后立即清空文本域，不依赖查询耗时/结果
                this.pasteText = ''
                this.search()
            },
            // 中控整档提交（update 为全量字段）：绑定侧取表单内容，解绑侧保持原值仅清空车架
            controlInput(row, chassisNo) {
                return {
                    controlNo: row.controlNo, controlSN: row.controlSN || '', model: row.model || '',
                    chassisNo, deviceExpiryDate: row.deviceExpiryDate ? String(row.deviceExpiryDate).slice(0, 10) : null
                }
            },
            bindingInput(chassisNo) {
                return {
                    controlNo: this.controlNo, controlSN: this.controlForm.controlSN || '', model: this.controlForm.model || '',
                    chassisNo, deviceExpiryDate: this.controlForm.deviceExpiryDate || null
                }
            },
            // 查询：中控档案（回填表单）+ 车架占用（待解绑清单）+ 车架档案（是否需补建），全部按编号精确匹配
            async search() {
                if (!this.bothFilled || this.searching) return
                const controlNo = this.controlNo
                const chassisNo = this.chassisNo
                const seq = ++this.searchSeq
                this.searching = true
                this.loaded = false
                try {
                    const [ctrlRes, occRes, chaRes] = await Promise.all([
                        controlApi.list({ page: 1, size: 100, keywords: controlNo }),
                        controlApi.list({ page: 1, size: 100, keywords: chassisNo }),
                        chassisApi.list({ page: 1, size: 100, keywords: chassisNo })
                    ])
                    if (seq !== this.searchSeq) return // 已被重置或被更新的查询取代，丢弃过期结果
                    this.ctrlRow = (ctrlRes.items || []).find(x => x.controlNo === controlNo) || null
                    this.chaRow = (chaRes.items || []).find(x => x.chassisNo === chassisNo) || null
                    this.occupants = (occRes.items || []).filter(x => (x.chassisNo || '').trim() === chassisNo && x.controlNo !== controlNo)
                    // 表单以查询条件为准，已存在档案的字段回填，避免直接保存把原值清空
                    this.controlForm = {
                        controlNo,
                        controlSN: this.ctrlRow ? this.ctrlRow.controlSN || '' : '',
                        model: this.ctrlRow ? this.ctrlRow.model || '' : '',
                        deviceExpiryDate: this.ctrlRow && this.ctrlRow.deviceExpiryDate ? String(this.ctrlRow.deviceExpiryDate).slice(0, 10) : null
                    }
                    this.chassisForm = {
                        chassisNo,
                        motorNo: this.chaRow ? this.chaRow.motorNo || '' : '',
                        model: this.chaRow ? this.chaRow.model || '' : ''
                    }
                    this.queriedKey = controlNo
                    this.queriedChassis = chassisNo
                    this.loaded = true
                } catch (_) {
                    if (seq !== this.searchSeq) return
                    this.ctrlRow = null
                    this.chaRow = null
                    this.occupants = []
                } finally {
                    if (seq === this.searchSeq) this.searching = false
                }
            },
            // 保存：无二次确认，直接按下方表单核对后串行执行——车架建档/改档 → 解绑占用中控 → 中控建档/改档并绑定，成功后重查
            async save() {
                if (!this.canBind) return
                const chassisNo = this.chassisNo
                this.saving = true
                try {
                    const chassisInput = { chassisNo, motorNo: this.chassisForm.motorNo || '', model: this.chassisForm.model || '' }
                    if (this.chaRow) await chassisApi.update(this.chaRow.id, chassisInput)
                    else await chassisApi.create(chassisInput)
                    for (const o of this.occupants) await controlApi.update(o.id, this.controlInput(o, ''))
                    if (this.ctrlRow) await controlApi.update(this.ctrlRow.id, this.bindingInput(chassisNo))
                    else await controlApi.create(this.bindingInput(chassisNo))
                    this.$message.success(`已绑定：中控 ${this.controlNo} → 车架 ${chassisNo}`)
                    this.$emit('done')
                    await this.search()
                } catch (_) { /* 请求层已提示错误，保留表单内容便于修正后重试 */ } finally {
                    this.saving = false
                }
            }
        }
    }
</script>
